/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { GetPdfHtmlForPrint } from "../../utilities/api/courtBooking";
import { PrintINvoiceSummaryProps } from "../../utilities/types"
import "./printInvoiceSummary.css";
import { messages } from "../../utilities/Messages";
import generatePDF, { Options, Margin } from "react-to-pdf";
import { ResolvePrefix } from "../../utilities/utils";

const getMessage = messages.printInvoice;

const PrintInvoiceSummary = ({
  typeOfPrint = "",
  idHash = "",
  prefix = "",
  id = "",
}: PrintINvoiceSummaryProps) => {
  const [showToaster, setShowToaster] = useState(true);
  const [htmlContent, setHtmlComntent] = useState("");
  const divRef = useRef(null)

  useEffect(() => {
    getPrintHtml();
  }, []);

  const fileName = ResolvePrefix(prefix);
  const options: Options = {
    filename: `${fileName}${id}.pdf`,
    method: "save",
    page: {
      format: 'A4',
      orientation: 'portrait',
    },
  };

  const getPrintHtml = async () => {
    const result = await GetPdfHtmlForPrint(typeOfPrint, idHash);

    if (result?.statusCode === 200) {
      if (result?.data?.html == undefined) {
        toast.error(getMessage.try_aftre_some_time);
      } else {
        setShowToaster(false);
        setHtmlComntent(result?.data?.html);
      }
    } else {

      toast.error(result.response.data.message);

    }

  };

  return (
    <>
      <div
        dangerouslySetInnerHTML={{
          __html: JSON.parse(JSON.stringify(htmlContent)),
        }}
        id="pdfContent"
        ref={divRef}
      ></div>
      <div className="d-flex justify-content-center mb-4">
        <button className="btn btn-primary mx-3" onClick={() => generatePDF(divRef, options)}>Download</button>
      </div>
      {showToaster && <ToastContainer />}
    </>
  );
};
export { PrintInvoiceSummary };
